import { render, staticRenderFns } from "./vendor-contact-item.vue?vue&type=template&id=f0cd012a&scoped=true&"
import script from "./vendor-contact-item.vue?vue&type=script&lang=js&"
export * from "./vendor-contact-item.vue?vue&type=script&lang=js&"
import style0 from "./vendor-contact-item.vue?vue&type=style&index=0&id=f0cd012a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cd012a",
  null
  
)

export default component.exports